<template>
    <div id="home-main-video-container" v-if="show_main_video">
        <MainVideo @show-main-page="showHomePage" />
    </div>
    <div id="app-page-container" v-if="!show_main_video">
        <HeaderComponent />
        <MenuComponent />

        <div id="main-page" class="container">
            <router-view v-slot="{ Component }">
                <transition name="fade" mode="out-in">
                    <component :is="Component" />
                </transition>
            </router-view>
        </div>

        <FooterComponent />
    </div>
</template>

<script>
    import HeaderComponent from "./components/Header.vue"
    import FooterComponent from "./components/Footer.vue"
    import MenuComponent from './components/Menu.vue'
    import MainVideo from './components/MainVideo.vue'

    export default {
        name: "App",
        components: {
            HeaderComponent,
            FooterComponent,
            MenuComponent,
            MainVideo
        },
        data() {
            var show_main_video = false;

            return {
                show_main_video
            }
        },
        methods: {
            showHomePage: function() {
                this.show_main_video = false;
            }
        },
        mounted() {
            /*
            const video_container = document.getElementById("home-main-video-container");
            video_container.classList.add("home-main-video-container-fadeout");
            setTimeout(() => this.showHomePage(), 17000);
            */
        }
    };
</script>

<style lang="scss">
    @font-face {
        font-family: 'Ageo';
        src: url("./assets/fonts/ageo/Ageo-Regular.ttf");
    }

    #app {
        font-family: 'Ageo', Arial, Helvetica, sans-serif;
        color: #202c38;
        background-color: #FFF;
        font-size: 16px;
        overflow-x: hidden;
    }

    .row {
        --bs-gutter-x: 0;
    }

    .container {
        max-width: 80%;
    }

    ::-webkit-scrollbar {
        width: 16px;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 4px solid transparent;
        background-clip: content-box;
        background-color: #202c38;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s ease;
    }
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    #app-page-container {
        animation: home-content-fadein 2s ease-in-out 0s 1 normal forwards;
    }

    .home-main-video-container-fadeout {
        animation: home-video-fadeout 4s ease-in-out 13s 1 normal forwards;
    }

    @media (max-width: 560px) {
        #app {
            font-size: 15px;
        }

        .container {
            max-width: 90%;
        }
    }

    @media (max-width: 420px) {
        #app {
            font-size: 12px;
        }

        .container {
            max-width: 95%;
        }
    }

    @media (max-width: 340px) {
        #app {
            font-size: 10px;
        }
    }

    @media (max-width: 295px) {
        #app {
            font-size: 8px;
        }
    }

    @keyframes home-content-fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes home-video-fadeout {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }
</style>
